import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
export function defaultSwiperSettings() {
  var slidesPerView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var autoplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var autoHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return {
    modules: [Navigation, Pagination, Autoplay],
    autoplay: autoplay,
    speed: speed,
    slidesPerView: slidesPerView,
    centerInsufficientSlides: true,
    autoHeight: autoHeight,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    a11y: true
  };
}
export { Swiper };